import { render } from "./ViewUsers.vue?vue&type=template&id=a79b2da2"
import script from "./ViewUsers.vue?vue&type=script&lang=js"
export * from "./ViewUsers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__